import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ActivityJSONAModel } from "interfaces/jsona-models/ActivityJSONAModel";

export class ActivitySelector extends BaseApiSelector<ActivityJSONAModel> {
  constructor() {
    super(ResourceType.Activity);
  }
}
